import { PropertyGrid, TabPane } from '@leverege/ui-elements';
import { ItemEditor } from '@leverege/ui-attributes';
import { useValueChange } from '@leverege/ui-hooks';
import { ModelTypeSelector } from '@leverege/ui-plugin';
import { Plugins } from '@leverege/plugin';
import GalleryModel from "../GalleryModel.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function GalleryEditor(props) {
  const {
    value
  } = props;
  const onModelChange = useValueChange(GalleryModel, props);
  return /*#__PURE__*/_jsxs(TabPane, {
    children: [/*#__PURE__*/_jsx(TabPane.Tab, {
      tabId: "view",
      tabName: "View Options",
      children: /*#__PURE__*/_jsxs(PropertyGrid, {
        variant: "rsrcGalleryEditor|editor",
        columns: 2,
        children: [/*#__PURE__*/_jsx(PropertyGrid.Header, {
          title: "View Options"
        }), /*#__PURE__*/_jsx(PropertyGrid.Subheader, {
          title: "Thumbnail View"
        }), /*#__PURE__*/_jsx(PropertyGrid.Item, {
          children: ModelTypeSelector.createSelectorAndEditor({
            values: Plugins.get('RsrcThumbnailRendererModel'),
            value: GalleryModel.getThumbnail(value),
            eventData: 'setThumbnail',
            onChange: onModelChange,
            allowNone: false,
            isPropertyGrid: true,
            showInline: false
          })
        }), /*#__PURE__*/_jsx(PropertyGrid.Subheader, {
          title: "Selected View"
        }), /*#__PURE__*/_jsx(PropertyGrid.Item, {
          children: ModelTypeSelector.createSelectorAndEditor({
            values: Plugins.get('RsrcDetailRendererModel'),
            value: GalleryModel.getDetail(value),
            eventData: 'setDetail',
            onChange: onModelChange,
            allowNone: false,
            isPropertyGrid: true,
            showInline: false
          })
        })]
      })
    }), /*#__PURE__*/_jsx(TabPane.Tab, {
      tabId: "details",
      tabName: "Details",
      children: /*#__PURE__*/_jsx(ItemEditor, {
        eventData: "setDetails",
        onChange: onModelChange,
        value: GalleryModel.getDetails(value)
      })
    })]
  });
}